import { useState, useCallback } from "react";
import csc from "../assets/CSC.png";
import UserIcon from "../assets/user.svg";
import { useAuth } from "../utils/hooks/useAuth";
import { serverName } from "../config";
import digiIn from "../assets/Digital_India_logo.png";
import { PAGE_PATHS } from "../pages/page-paths";

type NavbarProps = {
  toggleSidebar?: () => void;
};

export function Navbar({ toggleSidebar }: NavbarProps) {
  const { admin } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);

  const logout = useCallback(() => {
    document.cookie = "access_token=;domain=" + serverName;
    window.location.href = PAGE_PATHS.DEFAULT;
  }, []);

  return (
    <header className="bg-white shadow-sm rounded-b-lg px-4 flex items-center justify-between fixed top-0 left-0 right-0 w-full z-50 p-2">
      <div className="flex items-center space-x-4">
        <button className="md:hidden mr-2" onClick={toggleSidebar}>
          <svg
            className="w-6 h-6 text-blue-900"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>

        <img className="w-16" src={csc} alt="csc" />
        <img className="w-16" src={digiIn} alt="digital-india" />
      </div>

      <div className="hidden md:flex flex-grow mx-6 items-center justify-between text-sm">
        <div className="flex items-center space-x-6">
          <p className="text-blue-900 font-medium bg-[#EDF2FA] rounded-lg px-4 py-2 text-gray-600">
            Admin Name: <span className="font-semibold">{admin?.name}</span>
          </p>
        </div>
      </div>

      <div className="relative">
        <div
          className="flex items-center space-x-2 cursor-pointer"
          onClick={() => setShowDropdown(!showDropdown)}
        >
          <span className="bg-gray-300 text-blue-900 font-semibold text-sm w-10 h-10 flex items-center justify-center rounded-full">
            <img src={UserIcon} className="m-2" alt="user" />
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-blue-900"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>

        {showDropdown && (
          <div className="absolute top-14 right-2 bg-white shadow-md rounded-lg w-40 p-4 z-10">
            <button
              onClick={logout}
              className="w-full border hover:bg-blue-700 text-blue px-4 py-2 text-sm font-medium rounded-full"
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
